function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLosAngelesAngelsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "187px",
    height: "250px",
    viewBox: "0 0 187 250",
    style: {
      enableBackground: "new 0 0 187 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M103.311,244.824h68.396c-6.314-4.291-11.898-11.805-14.387-20.408l-19.12-65.604 c-2.067-7.066,1.294-14.127,6.668-18.904c-7.63-2.351-14.397-7.636-16.521-14.951l-10.716-36.725 c15.228-5.098,25.146-14.116,25.146-24.599c0-13.685-16.931-24.893-40.507-28.1L93.313,4.824H83.294l-8.946,30.715 c-23.587,3.207-40.54,14.409-40.54,28.094c0,10.483,9.941,19.501,25.18,24.599l-10.705,36.725 c-2.112,7.315-8.902,12.601-16.532,14.951c5.363,4.777,8.747,11.838,6.679,18.904L19.3,224.416 c-2.533,8.604-8.073,16.117-14.365,20.408h68.396c-5.596-4.291-8.648-11.805-6.138-20.408l1.681-5.706h38.903l1.659,5.706 C111.936,233.02,108.884,240.533,103.311,244.824 M82.421,172.237l5.905-20.298l5.894,20.298H82.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003263"
    },
    d: "M160.205,240.174c-3.272-4.263-5.86-9.228-7.387-14.431L133.82,160.57 c-2.997-10.34,2.565-17.693,3.295-18.865c-6.602-3.572-11.434-9.019-13.27-15.449L112.29,86.59 c16.3-4.34,27.413-12.982,27.413-22.957c0-12.612-17.859-23.14-41.513-25.468L89.841,9.491h-3.03l-8.349,28.674 c-23.676,2.322-41.546,12.85-41.546,25.468c0,9.975,11.125,18.617,27.425,22.957l-11.556,39.666 c-1.869,6.431-6.68,11.877-13.281,15.449c0.741,1.172,6.314,8.525,3.284,18.865L23.8,225.743 c-1.515,5.203-4.114,10.168-7.387,14.431h47.363c-3.815-8.438-1.813-14.586-0.1-20.375l1.681-5.761h45.915l1.691,5.761 c1.681,5.789,3.693,11.938-0.121,20.375 M76.151,176.903l12.175-41.689l12.131,41.689H76.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CD1141"
    },
    d: "M100.899,73.839h0.011L94.817,52.9l0,0l1.194,4.169c-2.488-0.138-5.065-0.232-7.686-0.232v13.585 l36.481,125.059l8.382,28.686l14.421,8.631c-1.007-2.189-1.913-4.434-2.599-6.734l-18.158-62.147 c-2.854-9.715-1.283-13.906,0.785-19.768c-5.452-4.186-9.079-9.632-10.849-15.769l-13.778-47.336c-0.011,0-0.022,0.006-0.033,0.006 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CD1141"
    },
    d: "M92.595,45.259l-4.269-14.642v14.547C89.764,45.165,91.19,45.204,92.595,45.259"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CD1141"
    },
    d: "M43.219,224.925l11.656,7.873c-0.63-3.92-0.033-9.078,1.083-12.739l3.871-13.38l-8.006-11.197"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#CD1141"
    },
    points: "66.331,184.269 88.326,108.961 88.326,70.422 51.822,195.481 124.808,195.481  110.255,184.269  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#8F0028"
    },
    points: "88.326,108.961 110.255,184.269 124.808,195.481 88.326,70.422  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F0028"
    },
    d: "M147.61,232.798l-14.421-8.631l-8.382-28.686H51.822L88.326,70.422V56.837 c2.621,0,5.197,0.094,7.686,0.232L94.817,52.9c-0.321-0.022-0.652-0.033-0.984-0.044c-1.792-0.094-3.627-0.149-5.507-0.149 c-2.223,0-4.39,0.072-6.502,0.193L75.72,73.839l0,0l-2.079,7.21c-0.011,0-0.022,0-0.022-0.006l-13.79,47.336 c-1.77,6.137-5.363,11.583-10.848,15.769c2.057,5.861,3.638,10.053,0.796,19.768l-18.18,62.147 c-0.686,2.301-1.548,4.545-2.61,6.734h25.888l-11.656-7.873l8.604-29.443l8.006,11.197h56.961l3.926,13.38 c1.04,3.661,1.637,8.819,1.04,12.739"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F0028"
    },
    d: "M88.326,30.618l-4.269,14.642c1.404-0.055,2.831-0.094,4.269-0.094"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4CDD3"
    },
    d: "M75.72,73.839L75.72,73.839c-13.215-1.581-22.604-5.568-22.604-10.207 c0-5.341,12.363-9.787,28.708-10.732c2.112-0.122,4.28-0.193,6.502-0.193c1.88,0,3.715,0.055,5.507,0.149 c0.332,0.011,0.664,0.022,0.984,0.044l0,0c16.333,0.946,28.708,5.38,28.708,10.732c0,4.639-9.4,8.625-22.615,10.207h-0.011 l2.079,7.21c0.011,0,0.022-0.006,0.033-0.006c17.019-2.554,29.228-9.361,29.228-17.411c0-9.582-17.406-17.472-39.645-18.374 c-1.404-0.055-2.831-0.094-4.269-0.094s-2.864,0.039-4.269,0.094c-22.283,0.901-39.655,8.792-39.655,18.374 c0,8.05,12.186,14.862,29.216,17.411c0,0.006,0.011,0.006,0.022,0.006"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003263"
    },
    d: "M173.531,234.385h-2.024v5.519h-1.371v-5.519h-2.023v-1.199h5.419 M182.709,239.903h-1.371v-5.347 h-0.033l-1.946,5.347h-1.327l-1.868-5.347h-0.033v5.347h-1.371v-6.718h2.366l1.56,4.385h0.044l1.614-4.385h2.366V239.903z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLosAngelesAngelsLogo);
export default __webpack_public_path__ + "static/media/los-angeles-angels-logo.804cbf39ed1cbcaa875bad09ae763aeb.svg";
export { ForwardRef as ReactComponent };